
import Check from "../../../assets/outline/Check.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CheckIcon({ className, dataTestid = "CheckIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Check data-testid={dataTestid} className={classes} {...rest} />
  );
}
